<template>
  <el-card>
    <header slot="header">
      <h2>Manage Dropdown Lists</h2>
    </header>

    <section>
      <el-row>
        <el-col :span="12" :offset="6">
          <div style="display: flex; justify-content: space-between; margin-bottom: 2rem;">
            <h4>Coupon Family List</h4>
            <button class="btn btn-primary" @click="addGuaranteeTracker()" size="mini">Add Guarantee Tracker</button>
          </div>
        </el-col>
        <el-col :span="12" :offset="6">
          <div class="custom-tree-container">
            <div class="block" style="max-height: 35vh; overflow-y: scroll; padding-bottom: 10vh;">
              <el-tree
                  v-loading="loading"
                  :data="data"
                  node-key="id"
                  default-expand-all
                  :expand-on-click-node="false">
                    <span :class="{'tree-node': true, 'tree-node-key': node.level === 1, 'tree-node-item': node.level === 2,}" slot-scope="{ node, data }">
                      <el-input v-model="data.label" size="mini" @blur="saveChanges()"></el-input>
                      <span>
                        <el-button
                            v-if="node.level === 1"
                            type="text"
                            size="mini"
                            @click="() => append(data)">
                          Append
                        </el-button>
                        <el-button
                            type="text"
                            size="mini"
                            @click="() => delConfirm(node, data)">
                          Delete
                        </el-button>
                      </span>
                    </span>
              </el-tree>
            </div>
          </div>
        </el-col>
      </el-row>
    </section>
  </el-card>
</template>

<script>

import axios, {RepositoryError} from '../../repositories';

let id = 1000;

export default {
  name: 'CustomerServiceDropdownLists',
  data() {
    return {
      data: [],
      loading: false,
    }
  },

  async mounted() {
    this.loading = true;
    await Promise.all([
        this.fetch(),
      ]);
    this.loading = false;
  },

  methods: {
    async saveChanges() {
      try {
        this.loading = true;
        await axios.put(`/manage-dropdown/update-guarantee-tracker`, {
          data: this.data,
        })
      } catch (err) {
        if (err instanceof RepositoryError) { return }
        throw new Error(`Failed to update current coupon: ${err}`);
      } finally {
        this.loading = false;
      }
    },
    addGuaranteeTracker() {
      this.data.push({ id: id++, label: 'GUARANTEE TRACKER NAME', level: 1, children: [] });
    },
    append(data) {
      const newChild = { id: id++, label: 'GUARANTEE TRACKER DETAIL', children: [] };
      if (!data.children) {
        this.$set(data, 'children', []);
      }
      data.children.push(newChild);
    },
    remove(node, data) {
      const parent = node.parent;
      const children = parent.data.children || parent.data;
      const index = children.findIndex(d => d.id === data.id);
      children.splice(index, 1);
    },
    delConfirm(node, data) {
      this.$confirm('This will permanently delete the coupon. Continue?', 'Warning', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.remove(node, data);
        this.saveChanges();
      })
    },
    async fetch() {
      try {
        const response = await axios.get(`/manage-dropdown/guarantee-tracker-detail`);
        this.data = response.data;
      } catch (err) {
        if (err instanceof RepositoryError) {
          throw new Error(`Failed to fetch coupon list: ${err}`);
        }
        throw err;
      }
    },
  },
}
</script>

<style scoped>
  .tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 8px;
  }
  .tree-node-key {
    font-size: 16px;
    font-weight: bold;
  }
  .tree-node-item {
    font-size: 14px;
  }
  .el-input--mini .el-input__inner {
    border: none;
  }
  .el-tree-node__content:hover {
    background: none;
  }
</style>
